import React, { Component } from 'react'
import { io } from "socket.io-client"

import { NotificationsProvider } from '../../contexts/notificationsContext'

import { env } from '../../config/global'

import FetchNotify from './fetch-notify'

const socket = io(env.socket_io_url, {
  transports: ['websocket'],
  path: env.socket_io_path,
  query: {
    user_code: 'xxx',
  },
})

const fetch_notify = new FetchNotify()

class Notifications extends Component {
  state = {
    notify_billing_note_customers: [],
    notify_billing_note_suppliers: [],
    notify_finance_credits: [],
    notify_finance_debits: [],
    notify_credit_note_suppliers: [],
    notify_invoice_customers: [],
    notify_invoice_suppliers: [],
    notify_petty_cash_withdrawals: [],
    notify_purchase_requests: [],
    notify_purchase_orders: [],
    notify_purchase_returns: [],
    notify_promotion: [],
    notify_quotations: [],
    notify_sale_orders: [],
    notify_receipts: [],
    notify_receipt_payments: [],
    notify_receipt_cancels: [],
    notify_redeem_gifts: [],
    notify_sale_cut_offs: [],
    notify_schedule_plans: [],
    notify_stock_changes: [],
    notify_stock_issues: [],
    notify_stock_moves: [],
    notify_stock_move_mains: [],
    notify_stock_packs: [],
    notify_stock_poors: [],
    notify_stock_returns: [],
    notify_stock_unpacks: [],
    notify_stock_verify_counts: [],
    notification_setting: [],
    orders: [],
    leaves: [],
    salary_payments: [],
    salary_pay_slips: [],

    sections: [
      'receipt-payment',
      'receipt-return',
      'receipt-cancel',
      'sale-cut-off',
      'billing-note-customer',
      'billing-note-supplier',
      'finance-credit',
      'finance-debit',
      'invoice-customer',
      'petty-cash-withdrawal',
      'purchase-request',
      'purchase-order',
      'promotion',
      'notify_promotion',
      'invoice-supplier',
      'credit-note-supplier',
      'purchase-return',
      'redeem-gift',
      'schedule-plan',
      'stock-pack',
      'stock-poor',
      'stock-change',
      'stock-issue',
      'stock-move',
      'stock-move-main',
      'stock-return',
      'stock-unpack',
      'stock-verify-count',
      'notification',
      'notification-setting',
      'order',
      'leave',
      'salary-payment',
      'salary-pay-slip',
    ],

    billing_note_customers: {
      waits: [],
      docs: [],
    },
    billing_note_suppliers: {
      advise_suppliers: [],
      advise_billing_notes: [],
      approves: [],
      issues: [],
    },
    finance_credit: {
      waits: [],
      docs: [],
    },
    finance_debit: {
      waits: [],
      docs: [],
    },
    invoice_customers: {
      advise_customers: [],
      advise_sale_orders: [],
      cancels: [],
      docs: [],
    },
    petty_cash_withdrawals: {
      advise_petty_cash_withdrawals: [],
      waits: [],
      approves: [],
    },
    purchase_requests: {
      salesmans: [],
      waits: [],
      approves: [],
      not_approves: [],
      cancels: [],
    },
    purchase_orders: {
      advise_suppliers: [],
      advise_products: [],
      waits: [],
      approves: [],
      not_approves: [],
      cancels: [],
    },
    promotions: {
      waits: [],
      approves: [],
    },
    invoice_suppliers: {
      advise_suppliers: [],
      advise_purchase_orders: [],
      docs: [],
    },
    purchase_returns: {
      advise_suppliers: [],
      waits: [],
      docs: [],
    },
    credit_note_suppliers: {
      advises: [],
      waits: [],
      docs: [],
      successes: [],
    },
    notify_redeem_gifts: {
      waits: [],
      approves: [],
      not_approves: [],
    },
    stock_poors: {
      advises: [],
      fixs: [],
      claims: [],
    },
    stock_change: {
      waits: [],
      approves: [],
      not_approves: [],
    },
    stock_issues: {
      advises: [],
      waits: [],
      approves: [],
      not_approves: [],
    },
    stock_moves: {
      advise_stock_groups: [],
      advise_stock_requests: [],
      docs: [],
    },
    stock_move_mains: {
      requests: [],
      approves: [],
      not_approves: [],
      waits: [],
      successes: [],
    },
    stock_returns: {
      advise_stock_issues: [],
      advise_stock_issue_lists: [],
      docs: [],
    },
    stock_packs: {
      advise_stock_issues: [],
      docs: [],
    },
    stock_unpacks: {
      advise_stock_issues: [],
      docs: [],
    },
    receipts: {
      waits: [],
      approves: [],
      docs: [],
    },
    receipt_payments: {
      waits: [],
      docs: [],
    },
    stock_verify_counts: {
      waits: [],
      approves: [],
      not_approves: [],
    },
    notification_setting: {
      seen: [],
      unseen: [],
    },
    orders: {
      request_check_price: [],
      request_check_slip: [],
      request_check_track: [],
      cancel: [],
      success: [],
      payment_failed: [],
      customer_request_cancel: [],
      order_request_print: [],
      order_print: [],
    },
    leaves: {
      waits: [],
      approves: [],
      not_approves: [],
    },

    salary_payments: {
      waits: [],
      approves: [],
      not_approves: [],
    },

    salary_pay_slips: {
      waits: [],
      approves: [],
      not_approves: [],
    },
    notifications: [],
    fetching_billing_note_customer: true,
    fetching_billing_note_supplier: true,
    fetching_credit_note_supplier: true,
    fetching_finance_credit: true,
    fetching_finance_debit: true,
    fetching_invoice_customer: true,
    fetching_petty_cash_withdrawal: true,
    fetching_purchase_request: true,
    fetching_purchase_order: true,
    fetching_invoice_supplier: true,
    fetching_purchase_return: true,
    fetching_promotion: true,
    fetching_receipt: true,
    fetching_receipt_payment: true,
    fetching_sale_cut_off: true,
    fetching_schedule_plan: true,
    fetching_stock_change: true,
    fetching_stock_issue: true,
    fetching_stock_move: true,
    fetching_stock_move_main: true,
    fetching_stock_pack: true,
    fetching_stock_poor: true,
    fetching_stock_return: true,
    fetching_stock_unpack: true,
    fetching_stock_verify_count: true,
    fetching_notification_setting: true,
    fetching_order: true,
    fetching_leave: true,
    fetching_salary_payment: true,
    fetching_salary_pay_slip: true,

    fetching_all: true,
  }

  componentDidMount() {
    this._fetchNotifications(this.state.sections)
    this._setupSubscribe()
  }

  _setupSubscribe = () => {
    socket.on("receipt:get-request", () => this._fetchNotifications(['receipt-payment']))
    socket.on("receipt:get-verify", () => this._fetchNotifications(['receipt-payment']))

    socket.on("receipt:get-return-request", () => this._fetchNotifications(['receipt-return']))
    socket.on("receipt:get-return-verify", () => this._fetchNotifications(['receipt-return']))

    socket.on("receipt-request-cancel:get-request", () => this._fetchNotifications(['receipt-cancel']))
    socket.on("receipt-request-cancel:get-approve", () => this._fetchNotifications(['receipt-cancel']))
    socket.on("sale-cut-off:get-request", () => this._fetchNotifications(['sale-cut-off']))
    socket.on("sale-cut-off:get-approve", () => this._fetchNotifications(['sale-cut-off']))
    socket.on("billing-note-customer:fetch-notify", () => this._fetchNotifications(['billing-note-customer']))
    socket.on("billing-note-supplier:fetch-notify", () => this._fetchNotifications(['billing-note-supplier']))
    socket.on("finance-credit:fetch-notify", () => this._fetchNotifications(['finance-credit']))
    socket.on("finance-debit:fetch-notify", () => this._fetchNotifications(['finance-debit']))
    socket.on("invoice-customer:fetch-notify", () => this._fetchNotifications(['invoice-customer']))
    socket.on("petty-cash-withdrawal:fetch-notify", () => this._fetchNotifications(['petty-cash-withdrawal']))
    socket.on("purchase-request:fetch-notify", () => this._fetchNotifications(['purchase-request']))
    socket.on("purchase-order:fetch-notify", () => this._fetchNotifications(['purchase-order']))
    socket.on("promotion:fetch-notify", () => this._fetchNotifications(['promotion']))
    socket.on("redeem-gift:fetch-notify", () => this._fetchNotifications(['redeem-gift']))
    socket.on("invoice-supplier:fetch-notify", () => this._fetchNotifications(['invoice-supplier']))
    socket.on("credit-note-supplier:fetch-notify", () => this._fetchNotifications(['credit-note-supplier']))
    socket.on("purchase-return:fetch-notify", () => this._fetchNotifications(['purchase-return']))
    socket.on("schedule-plan:fetch-notify", () => this._fetchNotifications(['schedule-plan']))
    socket.on("stock-pack:fetch-notify", () => this._fetchNotifications(['stock-pack']))
    socket.on("stock-poor:fetch-notify", () => this._fetchNotifications(['stock-poor']))
    socket.on("stock-change:fetch-notify", () => this._fetchNotifications(['stock-change']))
    socket.on("stock-issue:fetch-notify", () => this._fetchNotifications(['stock-issue']))
    socket.on("stock-move:fetch-notify", () => this._fetchNotifications(['stock-move']))
    socket.on("stock-move-main:fetch-notify", () => this._fetchNotifications(['stock-move-main']))
    socket.on("stock-return:fetch-notify", () => this._fetchNotifications(['stock-return']))
    socket.on("stock-unpack:fetch-notify", () => this._fetchNotifications(['stock-unpack']))
    socket.on("stock-verify-count:fetch-notify", () => this._fetchNotifications(['stock-verify-count']))
    socket.on("notification:fetch-notify", () => this._fetchNotifications(['notification']))
    socket.on("notification-setting:fetch-notify", () => this._fetchNotifications(['notification-setting']))
    socket.on("order:fetch-notify", () => this._fetchNotifications(['order']))
    socket.on("leave:fetch-notify", () => this._fetchNotifications(['leave']))
    socket.on("salary-payment:fetch-notify", () => this._fetchNotifications(['salary-payment']))
    socket.on("salary-pay-slip:fetch-notify", () => this._fetchNotifications(['salary-pay-slip']))
  
  }

  _fetchNotifications = async (sections = []) => {
    console.log("_fetchNotifications",sections);
    const new_notifys = await fetch_notify.fetchNotifyBy(sections, this.props._USER)
    this.setState(state => ({ ...state, ...new_notifys, }))  
}

  _sendNotifications = (path, payload, next) => socket.emit(path, payload, () => next && next())

  render() {
    return (
      <NotificationsProvider
        value={{
          ...this.state,
          fetchNotifications: this._fetchNotifications,
          sendNotifications: this._sendNotifications,
        }}
      >
        {this.props.children}
      </NotificationsProvider>
    )
  }
}

export default Notifications